// Copyright 2019 Sorama B.V.

import {
    IWorkflowModuleConfig,
    WorkflowModuleType,
} from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { CAMiV64GuidanceCatalog } from "./GuidanceCatalog/CAMiV64GuidanceCatalog";
import { FarFieldAnalysisGuidanceCatalog } from "./GuidanceCatalog/FarFieldAnalysisGuidanceCatalog";
import { GettingStartedGuidanceCatalog } from "./GuidanceCatalog/GettingStartedGuidanceCatalog";
import { HomeGuidanceCatalog } from "./GuidanceCatalog/HomeGuidanceCatalog";
import { MeasurementSetupGuidanceCatalog } from "./GuidanceCatalog/MeasurementSetupGuidanceCatalog";
import { MeasuringGuidanceCatalog } from "./GuidanceCatalog/MeasuringGuidanceCatalog";
import { NearFieldAnalysisGuidanceCatalog } from "./GuidanceCatalog/NearFieldAnalysisGuidanceCatalog";
import { OtherGuidanceCatalog } from "./GuidanceCatalog/OtherGuidanceCatalog";
import { ProductSoundDesignGuidanceCatalog } from "./GuidanceCatalog/ProductSoundDesignGuidanceCatalog";
import { PsychoacousticsGuidanceCatalog } from "./GuidanceCatalog/PsychoacousticsGuidanceCatalog";
import { SoundTheoryGuidanceCatalog } from "./GuidanceCatalog/SoundTheoryGuidanceCatalog";
import { SpectralTimeAnalysisGuidanceCatalog } from "./GuidanceCatalog/SpectralTimeAnalysisGuidanceCatalog";
import { StreamingGuidanceCatalog } from "./GuidanceCatalog/StreamingGuidanceCatalog";
import { TechnicalTroubleshootingGuidanceCatalog } from "./GuidanceCatalog/TechnicalTroubleshootingGuidanceCatalog";
import { IWorkflowModuleCatalog } from "./IWorkflowModuleCatalog";
import { AnalysisWorkflowModuleCatalog } from "./WorkflowModuleCatalog/AnalysisWorkflowModuleCatalog";
import { ClientWorkflowModuleCatalog } from "./WorkflowModuleCatalog/ClientWorkflowModuleCatalog";
import { HelpWorkflowModuleCatalog } from "./WorkflowModuleCatalog/HelpWorkflowModuleCatalog";
import { IndustrialReportWorkflowModuleCatalog } from "./WorkflowModuleCatalog/IndustrialReportWorkflowModuleCatalog";
import { MeasurementWorkflowModuleCatalog } from "./WorkflowModuleCatalog/MeasurementModuleCatalog";
import { MeasurementSetupWorkflowModuleCatalog } from "./WorkflowModuleCatalog/MeasurementSetupWorkflowModuleCatalog";
import { PresentationWorkflowModuleCatalog } from "./WorkflowModuleCatalog/PresentationWorkflowModuleCatalog";
import { ProjectModuleCatalog } from "./WorkflowModuleCatalog/ProjectModuleCatalog";
import { StreamerWorkflowModuleCatalog } from "./WorkflowModuleCatalog/StreamerWorkflowModuleCatalog";
import { UserWorkflowModuleCatalog } from "./WorkflowModuleCatalog/UserWorkflowModuleCatalog";

export class WorkflowModuleCatalog implements IWorkflowModuleCatalog {
    private modules: IWorkflowModuleConfig[];

    public getWorkflowModules(type?: WorkflowModuleType | WorkflowModuleType[]): IWorkflowModuleConfig[] {
        if (!this.modules) {
            const catalogs = [
                AnalysisWorkflowModuleCatalog,
                ClientWorkflowModuleCatalog,
                HelpWorkflowModuleCatalog,
                MeasurementWorkflowModuleCatalog,
                ProjectModuleCatalog,
                MeasurementSetupWorkflowModuleCatalog,
                StreamerWorkflowModuleCatalog,
                UserWorkflowModuleCatalog,
                GettingStartedGuidanceCatalog,
                StreamingGuidanceCatalog,
                MeasuringGuidanceCatalog,
                MeasurementSetupGuidanceCatalog,
                SpectralTimeAnalysisGuidanceCatalog,
                FarFieldAnalysisGuidanceCatalog,
                NearFieldAnalysisGuidanceCatalog,
                SoundTheoryGuidanceCatalog,
                ProductSoundDesignGuidanceCatalog,
                TechnicalTroubleshootingGuidanceCatalog,
                OtherGuidanceCatalog,
                HomeGuidanceCatalog,
                PsychoacousticsGuidanceCatalog,
                IndustrialReportWorkflowModuleCatalog,
                PresentationWorkflowModuleCatalog,
                CAMiV64GuidanceCatalog,
            ];

            const modules: IWorkflowModuleConfig[] = [];

            for (const catalog of catalogs) {
                for (const property of Object.keys(catalog)) {
                    modules.push(catalog[property]);
                }
            }

            this.modules = modules;
        }

        const types = type ? (Array.isArray(type) ? type : [type]) : undefined;
        return this.modules.filter((x) => !type || types.find((y) => y == x.moduleType));
    }
}
